import { type SessionCreateResponse } from "../models/session-create-response"
import type { HttpAdapter } from "../../core/adapters/axios.adapter"

export type OTPCode = number

export class OTPService {
  constructor(private httpAdapter: HttpAdapter) { }

  async verifyOTP(email: string, OTPCode: OTPCode): Promise<SessionCreateResponse | null> {
    try {
      // const response = await this._httpService.query('sessions/', {
      // method: 'POST',
      // headers: this.#HEADERS,
      // data: { email, OTPCode }
      // })
      const response = await this.httpAdapter.post('', {email, OTPCode})
        if(response.status < 200 || response.status >= 300) { throw new Error('invalidOTPCode')
    }
      const body = response.data
    return body
  } catch(error) {
    console.error(error)
    return null
  }
}
}

// export const otpService = new OTPService(httpService)